import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { UrlService } from '@service/url/url.service';
import { ContactsTable, RestService, TruckSearchTable } from 'cargo-chief-commons';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { ACCOUNT_TYPE } from '@domain/constants/app-variables';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';

@Component({
	selector: 'app-contact-details-modal',
	templateUrl: './contact-details-modal.component.html',
	styleUrls: ['./contact-details-modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ContactDetailsModalComponent implements OnInit {
	@Input() text: string;
	@Input() contactsCount: number;
	@Input() carrierId: string;
	@Input() editPrimaryContact: boolean;
	@Input() showButton: boolean;
	@Input() segmentEvent: boolean;
	@Input() mc: string;
	@Input() dot: string;
	@Input() showCarrier: boolean;
	@Input() isCustomerCarrier: boolean = false;
	@Input() isFeedbackEnabled: boolean;
	@Input() carrierBusinessName: boolean;
	@Input() carrierHQ: string;
	@Input() isLane: boolean;
	@Input() lanePath: string;
	@Input() carrierLastFmcsaUpdate: string;
	@Input() drivers: string;
	@Input() powerUnits: string;
	@Input() phone: string;
	@Input() frequency: string;
	@Input() originDeadhead: string;
	@Input() destinationDeadhead: string;
	@Output() carrierSetup: EventEmitter<boolean> = new EventEmitter();

	constructor(public dialog: MatDialog) {}

	ngOnInit() {}

	showCarrierContactDetails(): void {
		const dialogRef = this.dialog.open(ContactDialogComponent, {
			width: '950px',
			data: {
				contactsCount: this.contactsCount,
				carrierId: this.carrierId,
				segmentEvent: this.segmentEvent,
				mc: this.mc,
				dot: this.dot,
				editPrimaryContact: this.editPrimaryContact,
				showCarrier: this.showCarrier,
				isFeedbackEnabled: this.isFeedbackEnabled,
				carrierBusinessName: this.carrierBusinessName,
				carrierHQ: this.carrierHQ,
				isLane: this.isLane,
				lanePath: this.lanePath,
				carrierLastFmcsaUpdate: this.carrierLastFmcsaUpdate,
				drivers: this.drivers,
				powerUnits: this.powerUnits,
				phone: this.phone,
				isCustomerCarrier: this.isCustomerCarrier,
				frequency: this.frequency,
				originDeadhead: this.originDeadhead,
				destinationDeadhead: this.destinationDeadhead,
			},
			disableClose: true,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result != null) {
				this.carrierSetup.emit(result);
			}
		});
	}
}

@Component({
	selector: 'contact-details-dialog',
	templateUrl: 'modal.template.html',
})
export class ContactDialogComponent implements OnInit {
	USER_ACCOUNT_TYPE = null;
	ACCOUNT_TYPE = ACCOUNT_TYPE;
	isCustomerCarrierUpdated = false;
	contactList: ContactsTable[] = null;
	capacitySearch = {} as TruckSearchTable;
	userResponseSegmentPayload = null;

	constructor(
		public dialogRef: MatDialogRef<ContactDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		private cargochief: Cargochief,
		private segmentWrapper: SegmentWrapperService,
		public accountSettings: AccountSettingsService
	) {}

	ngOnInit() {
		this.USER_ACCOUNT_TYPE = this.cargochief.USER_ACCOUNT_TYPE;
		this.getContactsList();
		this.capacitySearch.carrierId = this.data.carrierId;
		this.capacitySearch.customerCarrier = this.data.isCustomerCarrier;
	}

	getContactsList() {
		this.contactList = null;
		const contactsUrl = this.urlService.contactsUrl(this.data['carrierId']);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				result['carrier'] = this.getCarrierInfo();
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
			}
		);
	}

	closeDialog(): void {
		this.isCustomerCarrierUpdated
			? this.dialogRef.close(this.data.isCustomerCarrier)
			: this.dialogRef.close(null);
	}

	allQuestionsAnswered(payload: any) {
		if (!this.utilService.isNullOrUndefined(payload)) {
			this.userResponseSegmentPayload = payload;
		} else {
			this.userResponseSegmentPayload = payload;
		}
	}

	submitFeedback() {
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_submitted_carrier_feedback,
			this.userResponseSegmentPayload
		);
		this.closeDialog();
	}

	getCarrierInfo() {
		return {
			businessName: this.data.carrierBusinessName,
			mc: this.data.mc,
			dot: this.data.dot,
			carrierId: this.data.carrierId,
		};
	}
}
